<template>
    <div>Redirigiendo...</div>
</template>

<script>
export default {
    name: 'viewNota',
    props:['params'],
    created(){
        if(this.params){
            window.location = "http://d2.bdtr.net/n.php?c="+this.params
        }else{
            this.$router.push('/');
        }
    }
}
</script>